import AccountBalance from '@material-ui/icons/AccountBalance'
import AccountBox from '@material-ui/icons/AccountBox'
import AssessmentIcon from '@material-ui/icons/Assessment'
import Assignment from '@material-ui/icons/Assignment'
import BlockIcon from '@material-ui/icons/Block'
import Description from '@material-ui/icons/Description'
import DvrIcon from '@material-ui/icons/Dvr'
import History from '@material-ui/icons/History'
import ListAlt from '@material-ui/icons/ListAlt'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import LockOpenIcon from '@material-ui/icons/LockOpen'
import MonetizationOn from '@material-ui/icons/MonetizationOn'
import PersonAddDisabledIcon from '@material-ui/icons/PersonAddDisabled'
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'
import QueryBuilder from '@material-ui/icons/QueryBuilder'
import Receipt from '@material-ui/icons/Receipt'
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications'
import { AuthContext, RouteByMenu } from 'elentari'
import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react'
import IdleTimer from 'react-idle-timer'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'
import SecureRoute from '../../lib/SecureRoute'
import api, { restApi } from '../../services/Api'
import { deepCopyFunction } from '../../utils/Utils'
import { CentroCustoTabs, CentrosCusto } from '../CentrosCusto'
import { MercadoriaTabs, Mercadorias } from '../Mercadorias'
import { Solicitacoes, SolicitacoesAnalista } from '../Solicitacoes'
import SolicitacaoForm from '../Solicitacoes/SolicitacaoForm'
import { UsuarioTabs, Usuarios, useAbility } from '../Usuarios'
import PainelSolicitacoesGeral from '../Paineis/Gerais/PainelSolicitacoesGeral'
import PainelSolicitacoesTempoReal from '../Paineis/TempoReal/PainelSolicitacoesTempoReal'
import {
  PainelTempoSolicitacao,
  TempoSolicitacoes
} from '../Paineis/TempoSolicitacoes'
import PainelTarefasTempoReal from '../Paineis/Tarefas/TempoReal/PainelTarefasTempoReal'
import PainelTarefasLiberadasViagem from '../Paineis/Tarefas/Viagem/PainelTarefasLiberadaViagem'

import {
  Badge,
  Grid,
  MenuItem,
  MenuList,
  Popover,
  Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate'
import BusinessIcon from '@material-ui/icons/Business'
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline'
import FindInPageIcon from '@material-ui/icons/FindInPage'
import Landscape from '@material-ui/icons/Landscape'
import MessageIcon from '@material-ui/icons/Message'
import NotificationsActiveRoundedIcon from '@material-ui/icons/NotificationsActiveRounded'
import SecurityIcon from '@material-ui/icons/Security'
import SettingsIcon from '@material-ui/icons/Settings'
import WarningIcon from '@material-ui/icons/Warning'
import * as R from 'ramda'
import { Carregando } from '../../components'
import AlertDialog from '../../components/AlertDialog'
import AppWrap from '../../components/AppWrap/AppWrap'
import Blacklist from '../Blacklist/Blacklist'
import BlacklistForm from '../Blacklist/BlacklistForm'
import BloqueioManual from '../BloqueioManual/BloqueioManual'
import BloqueioManualForm from '../BloqueioManual/BloqueioManualForm'
import { Configuracoes, ConfiguracoesForm } from '../Configuracoes'
import { ConfiguracoesContext } from '../Configuracoes/ConfiguracoesContext'
import ConsultaHistoricoCard from '../ConsultaHistorico/ConsultaHistoricoCard'
import { LogDIs } from '../LogDI'
import { LogFlex } from '../LogFlex'
import { LogLiberacaoAutomatica } from '../LogLiberacaoAutomatica'
import { LogSerpro } from '../LogSerpro'
import Logs from '../Logs/Logs'
import MensagemForm from '../Mensagens/MensagemForm'
import MensagemView from '../Mensagens/MensagemView'
import MensagensList from '../Mensagens/MensagensList'
import UsuarioLerMensagem from '../Mensagens/UsuarioLerMensagem'
import NotificacoesAnalista from '../Notificacoes/NotificacoesAnalista'
import Relatorios from '../Relatorios/Relatorios'
import { RiscoForm, RiscoList } from '../Riscos'
import ListaAviso from '../Solicitacoes/ListaAvisos/ListaAviso'
import ListaAvisoForm from '../Solicitacoes/ListaAvisos/ListaAvisoForm'
import {
  SolicitacoesEmbarcador,
  SolicitacoesEmbarcadorForm
} from '../SolicitacoesEmbarcador'
import SolicitacoesHistorico from '../SolicitacoesHistorico/SolicitacoesHistorico'
import SolicitacoesHistoricoCard from '../SolicitacoesHistorico/SolicitacoesHistoricoCard'
import Tarefa from '../Tarefa/Tarefa'
import TarefaEmbarcador from '../Tarefa/TarefaEmbarcador/TarefaEmbarcador'
import TarefaEmbarcadorForm from '../Tarefa/TarefaEmbarcador/TarefaEmbarcadorForm'
import TarefaForm from '../Tarefa/TarefaForm'
import TarefasAnalista from '../Tarefa/TarefasAnalista'
import TransportadoraConfiavel from '../TransportadoraConfiavel/TransportadoraConfiavel'
import TransportadoraConfiavelForm from '../TransportadoraConfiavel/TransportadoraConfiavelForm'
import UnidadeNegocio from '../UnidadeNegocio/UnidadeNegocio'
import UnidadeNegocioTabs from '../UnidadeNegocio/UnidadeNegocioTabs'
import UsuarioSimpleForm from '../Usuarios/UsuarioSimpleForm'
import { CenarioList } from '../Cenarios'
import { CenarioForm } from '../Cenarios/CenarioForm'
import { BRAND } from '../../branding'

const TEMPO_PING_5_MIN = 1000 * 60 * 5

const allMenuItems = [
  {
    name: 'solicitacoes',
    label: 'Solicitações',
    icon: ListAlt,
    pathname: '/solicitacoes',
    list: Solicitacoes,
    form: SolicitacaoForm
  },
  {
    name: 'solicitacoesAnalista',
    label: 'Minhas Solicitações',
    icon: Assignment,
    pathname: '/solicitacoesAnalista',
    list: SolicitacoesAnalista,
    form: SolicitacaoForm
  },
  {
    name: 'solicitacoesEmbarcador',
    label: 'Minhas Solicitações',
    icon: ListAlt,
    pathname: '/solicitacoesEmbarcador',
    list: SolicitacoesEmbarcador,
    form: SolicitacoesEmbarcadorForm
  },
  {
    name: 'relatorios',
    label: 'Relatórios',
    icon: DvrIcon,
    pathname: '/relatorios',
    list: () => {},
    form: () => {},
  },
  {
    name: 'paineis-solicitacoes',
    group: true,
    checkAbilityItems: true,
    label: 'Painéis de Solicitações',
    icon: AssessmentIcon,
    pathname: '/paineis-solicitacoes',
    items: [
      {
        pathname: '/paineis-solicitacoes/tempo-real',
        checkAbility: true,
        label: 'Tempo Real',
        name: 'paineis-solicitacoes-tempo-real',
        list: () => {},
        form: () => {},
      },
      {
        pathname: '/paineis-solicitacoes/gerais',
        checkAbility: true,
        label: 'Gerais',
        name: 'paineis-solicitacoes-tempo-gerais',
        list: () => {},
        form: () => {},
      },
      {
        pathname: '/paineis-solicitacoes/tempo-solicitacao',
        checkAbility: true,
        label: 'Tempo Solicitações',
        name: 'paineis-solicitacoes-tempo-solicitacao',
        list: () => {},
        form: () => {},
      }
    ]
  },
  {
    name: 'lerMensagem',
    label: 'Ler mensagens',
    icon: ChatBubbleOutlineIcon,
    pathname: '/ler-mensagem',
    list: () => {},
    form: () => {},
  },

  {
    name: 'solicitacoesHistorico',
    label: 'Histórico',
    icon: History,
    pathname: '/solicitacoesHistorico',
    list: SolicitacoesHistorico,
    form: SolicitacoesHistoricoCard
  },
  {
    name: 'consultaHistorico',
    label: 'Consulta',
    icon: QueryBuilder,
    pathname: '/consultaHistorico',
    list: () => {},
    form: () => {},
  },
  {
    name: 'tarefa',
    label: 'Solicitação de Monitoramento',
    icon: Description,
    pathname: '/tarefa',
    list: Tarefa,
    form: TarefaForm,
  },
  {
    name: 'tarefasAnalista',
    label: 'Minhas Solicitações de Monitoramento',
    icon: Receipt,
    pathname: '/tarefasAnalista',
    list: TarefasAnalista,
    form: TarefaForm,
  },
  {
    name: 'tarefasEmbarcador',
    label: 'Minhas Solicitações de Monitoramento',
    icon: Receipt,
    pathname: '/tarefasEmbarcador',
    list: TarefaEmbarcador,
    form: TarefaEmbarcadorForm,
  },
  {
    name: 'paineis-tarefas',
    group: true,
    checkAbilityItems: true,
    label: 'Painéis de Solicitações de Monitoramento',
    icon: AssessmentIcon,
    pathname: '/paineis-tarefas',
    items: [
      {
        pathname: '/paineis-tarefas/tempo-real',
        checkAbility: true,
        label: 'Tempo Real',
        name: 'paineis-tarefas-tempo-real',
        list: () => {},
        form: () => {},
      },
      {
        pathname: '/paineis-tarefas/viagem',
        checkAbility: true,
        label: 'Viagens',
        name: 'paineis-tarefas-viagem',
        list: () => {},
        form: () => {},
      }
    ]
  },
  {
    name: 'bloqueio-manual-kmm',
    label: 'Bloqueio Manual',
    icon: BlockIcon,
    pathname: '/bloqueio-manual-kmm',
    list: BloqueioManual,
    form: BloqueioManualForm,
  },
  {
    name: 'blacklist-kmm',
    label: 'Blacklist',
    icon: PersonAddDisabledIcon,
    pathname: '/blacklist-kmm',
    list: Blacklist,
    form: BlacklistForm,
  },
  {
    name: 'admin',
    group: true,
    checkAbilityItems: true,
    label: 'Administração',
    icon: SettingsApplicationsIcon,
    items: [
      {
        name: 'usuarios',
        label: 'Usuários',
        icon: AccountBox,
        pathname: '/usuarios',
        list: Usuarios,
        form: UsuarioTabs,
      },
      {
        name: 'listaAviso',
        label: 'Lista de Avisos',
        icon: PlaylistAddCheckIcon,
        pathname: '/listaAviso',
        list: ListaAviso,
        form: ListaAvisoForm,
      },
      {
        name: 'unidadeNegocio',
        label: 'Unidade de Negócio',
        icon: BusinessIcon,
        pathname: '/unidadeNegocio',
        list: UnidadeNegocio,
        form: UnidadeNegocioTabs,
      },
      {
        name: 'centrosCusto',
        label: 'Centros de Custo',
        icon: AccountBalance,
        pathname: '/centrosCusto',
        list: CentrosCusto,
        form: CentroCustoTabs,
      },
      {
        name: 'mercadorias',
        label: 'Mercadorias',
        icon: Landscape,
        pathname: '/mercadorias',
        list: Mercadorias,
        form: MercadoriaTabs,
      },
      {
        name: 'transportadoraConfiavel',
        label: 'Transportadoras Confiáveis',
        icon: LocalShippingIcon,
        pathname: '/transportadoraConfiavel',
        list: TransportadoraConfiavel,
        form: TransportadoraConfiavelForm,
      },
      {
        name: 'mensagens',
        label: 'Mensagens',
        icon: MessageIcon,
        pathname: '/mensagens',
        list: MensagensList,
        form: MensagemForm,
      },
      {
        name: 'configuracoes',
        label: 'Configurações',
        icon: SettingsIcon,
        pathname: '/configuracoes',
        list: Configuracoes,
        form: ConfiguracoesForm,
      },
      {
        name: 'riscos',
        label: 'Riscos',
        icon: WarningIcon,
        pathname: '/riscos',
        list: RiscoList,
        form: RiscoForm,
      },
      {
        name: 'cenarios',
        label: 'Cenários',
        icon: AssignmentLateIcon,
        pathname: '/cenarios',
        list: CenarioList,
        form: CenarioForm,
      }
    ]
  },
  {
    name: 'logs-audtioria',
    group: true,
    checkAbilityItems: true,
    label: 'Logs de Audtitoria',
    icon: FindInPageIcon,
    items: [
      {
        name: 'LogLiberacaoAutomatica',
        label: 'Logs Liberação Automática',
        icon: LockOpenIcon,
        pathname: '/logLiberacaoAutomatica',
        list: () => {},
        form: () => {},
      },
      {
        name: 'logSerpro',
        label: 'Logs Serpro',
        icon: SecurityIcon,
        pathname: '/logSerpro',
        list: () => {},
        form: () => {},
      },
      {
        name: 'logDIs',
        label: 'Logs DI',
        icon: MonetizationOn,
        pathname: '/logDIs',
        list: () => {},
        form: () => {},
      },
      {
        name: 'logs',
        label: 'Logs',
        icon: AssignmentLateIcon,
        pathname: '/logs',
        list: () => {},
        form: () => {},
      },
      {
        name: 'logFlex',
        label: 'Logs Flex',
        icon: MonetizationOn,
        pathname: '/logFlex',
        list: () => {},
        form: () => {},
      }
    ]
  }
]

const useStyles = makeStyles(theme => ({
  logo: {
    maxWidth: '100%'
  },
  logoOpen: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 128,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  logoClose: {
    width: 40,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  }
}))

const breadcrumbsPropertiesMap = {
  metas: 'Metas',
  gestores: 'Gestores',
  simpleForm: 'Edição Simples',
  analistasPreferenciais: 'Analistas Preferenciais'
}

const Home = () => {
  const authContext = useContext(AuthContext)
  const history = useHistory()
  const [open, setOpen] = useState(localStorage.toggleDrawer === '1')
  const [menu, setMenu] = useState(false)
  const [alert, setAlert] = useState(false)
  const [qtdMensagens, setQtdMensagens] = useState(0)

  const classes = useStyles()
  const { user } = authContext

  const onToggleDrawer = status => {
    setOpen(status === 'open')
  }

  const TEMPO_INATIVIDADE_30_MIN = useContext(ConfiguracoesContext)
  const idleTimer = useRef(null)

  const fetchCountMessages = useCallback(async () => {
    const responseCount = await restApi.get(
      `usuarios/${user?.id}/mensagem-usuarios/count`,
      { where: { foiLida: false } }
    )
    if (responseCount.ok) {
      const { count } = responseCount?.data
      setQtdMensagens(count)
      return count
    }
    return qtdMensagens
  }, [user])

  useEffect(() => {
    const interval = setInterval(fetchCountMessages, 5 * 60 * 1000)
    return () => clearInterval(interval)
  }, [fetchCountMessages])

  useEffect(() => {
    const fetch = async () => {
      const quantidadeInicial = await fetchCountMessages()
      if (quantidadeInicial > 0) {
        setAlert(true)
      }
    }
    fetch()
  }, [fetchCountMessages])

  const onIdle = async () => {
    await api.logout()
    delete localStorage.user
    window.location.replace('/')
  }

  const onAction = () => {
    api.ping()
  }

  const handleLerMensagens = () => {
    history.push('/ler-mensagem')
    setQtdMensagens(0)
    setAlert(false)
  }

  const [ability] = useAbility()
  if (!ability) {
    return <Carregando />
  }
  const menuItems = deepCopyFunction(allMenuItems)
    .map(menuItem => {
      if (menuItem.group && menuItem.checkAbilityItems) {
        menuItem.items = menuItem.items.filter(item => {
          return !(item.checkAbility && !ability.can('read', item.name))
        })
      }
      if (ability.can('read', menuItem.name)) {
        return menuItem
      }
      return false
    })
    .filter(menuItem => !!menuItem)

  const getRedirectPath = () => {
    if (user.realm === 'embarcador') {
      return '/solicitacoesEmbarcador'
    } else if (user.realm === 'analista' || user.realm === 'analista_2') {
      return '/solicitacoesAnalista'
    } else if (user.realm === 'analista_op' || user.realm === 'analista_op_2') {
      return '/tarefasAnalista'
    } else {
      return '/solicitacoes'
    }
  }

  return (
    <Fragment>
      <IdleTimer
        ref={idleTimer}
        element={document}
        onIdle={onIdle}
        onAction={onAction}
        throttle={TEMPO_PING_5_MIN}
        timeout={TEMPO_INATIVIDADE_30_MIN}
      />
      <NotificacoesAnalista />
      <AppWrap
        onToggleDrawer={onToggleDrawer}
        menuItems={menuItems}
        pathReadableMap={breadcrumbsPropertiesMap}
        userAvatarProps={{
          action: (
            <div style={{ textAlign: 'right' }}>
              <Typography variant="caption">
                <b>OPÇÕES</b>
              </Typography>
            </div>
          ),
          label: 'Olá,',
          onActionClick: () => setMenu(true)
        }}
        theme="dark"
        logo={
          <div className={open ? classes.logoOpen : classes.logoClose}>
            <img alt={BRAND.name} src={BRAND.alternative} className={classes.logo} />
          </div>
        }
        customBar={
          qtdMensagens > 0 && (
            <Grid
              item
              onClick={handleLerMensagens}
              style={{
                cursor: 'pointer'
              }}
            >
              <Typography variant="h5" color="secondary" alt="oiee">
                <Badge badgeContent={qtdMensagens} color="primary">
                  <NotificationsActiveRoundedIcon
                    fontSize="large"
                    color="action"
                  />
                </Badge>
              </Typography>
            </Grid>
          )
        }
      >
        <Popover
          anchorEl={null}
          className={classes.popover}
          keepMounted
          open={menu}
          onClose={() => setMenu(false)}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
        >
          <MenuList dense={true}>
            <MenuItem
              onClick={() => {
                history.push(`/usuarios/simpleForm/${user.id}`)
                setMenu(false)
              }}
            >
              Editar Dados
            </MenuItem>
            <MenuItem
              onClick={() => {
                authContext.logout && authContext.logout()
              }}
            >
              Sair
            </MenuItem>
          </MenuList>
        </Popover>
        <Switch>
          <SecureRoute
            ability={ability}
            name="solicitacoes"
            path="/solicitacoes/:id"
            exact
            component={SolicitacaoForm}
          />
          <SecureRoute
            ability={ability}
            name="relatorios"
            path="/relatorios"
            exact
            component={Relatorios}
          />
          <Route
            exact
            path="/"
            render={() => <Redirect to={getRedirectPath()} />}
          />
          <Route
            exact
            path="/usuarios/simpleForm/:id"
            component={UsuarioSimpleForm}
          />
          <Route path="/relatorios" exact component={Relatorios} />
          <Route
            path="/paineis-solicitacoes/tempo-real"
            exact
            component={PainelSolicitacoesTempoReal}
          />
          <Route
            path="/paineis-solicitacoes/gerais"
            exact
            component={PainelSolicitacoesGeral}
          />
          <Route
            path="/paineis-solicitacoes/tempo-solicitacao"
            exact
            component={TempoSolicitacoes}
          />
          <Route
            path="/paineis-solicitacoes/tempo-solicitacao/:id"
            exact
            component={PainelTempoSolicitacao}
          />
          <Route
            path="/paineis-tarefas/tempo-real"
            exact
            component={PainelTarefasTempoReal}
          />
          <Route
            path="/paineis-tarefas/viagem"
            exact
            component={PainelTarefasLiberadasViagem}
          />
          <Route
            path="/logLiberacaoAutomatica"
            exact
            component={LogLiberacaoAutomatica}
          />
          <Route path="/logSerpro" exact component={LogSerpro} />
          <Route path="/logDIs" exact component={LogDIs} />
          <Route path="/logs" exact component={Logs} />
          <Route path="/logFlex" exact component={LogFlex} />
          <Route
            path="/consultaHistorico"
            exact
            component={ConsultaHistoricoCard}
          />
          =
          <Route path="/mensagens/:id/view" exact component={MensagemView} />
          <Route path="/ler-mensagem" exact component={UsuarioLerMensagem} />
          <RouteByMenu
            menuItems={R.flatten(
              menuItems.map(item => (item.group ? item.items : item))
            )}
          />
        </Switch>
        <AlertDialog
          open={alert}
          handleClose={() => setAlert(false)}
          closeButtonText="Fechar"
          primaryButtonText="Ler Mensagens"
          message="Você possui novas mensagens!"
          primaryAction={handleLerMensagens}
        />
      </AppWrap>
    </Fragment>
  )
}

export default Home
